var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommentReply({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0136566 11.5706C0.0676565 7.12281 3.90178 3.50053 8.67263 3.33875V0.999969C8.67263 0.448563 9.12081 0 9.67181 0C9.91966 0 10.159 0.0950624 10.3444 0.267562C10.3444 0.267562 14.5578 4.16847 15.7697 5.38491C15.918 5.53466 16 5.75275 16 5.99981C16 6.24688 15.918 6.46497 15.7697 6.61503C14.5578 7.83113 10.3444 11.7321 10.3444 11.7321C10.159 11.9046 9.91966 11.9996 9.67181 11.9996C9.12084 11.9996 8.67263 11.5511 8.67263 10.9997V8.66869C3.87641 8.73606 0.679125 10.25 0.679125 11.6663C0.679125 11.8506 0.530156 11.9996 0.346063 11.9996C0.340844 12.0003 0.335656 11.9999 0.333062 11.9996C0.148969 11.9996 0 11.8505 0 11.6663C0 11.6331 0.00456333 11.6009 0.0136566 11.5706Z",
    fill: "#778797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentReply);
export default __webpack_public_path__ + "static/media/comment_reply.b475a22d018e3219c26618b97a3da519.svg";
export { ForwardRef as ReactComponent };